import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactElement } from 'react';
import { RouterProvider } from 'react-router-dom';

import { router } from '@/app/router.js';
import { queryClient } from '@/lib/query/client-instance.js';

import { AuthProvider } from './AuthProvider.js';

/**
 * Порядок вложения несущий:
 *
 *   QueryClientProvider — внешний: и AuthProvider, и страницы обращаются к кэшу запросов.
 *   AuthProvider        — над роутером: guard'ы внутри маршрутов читают статус сессии
 *                         через useAuth(), и провайдер обязан быть их предком.
 *   RouterProvider      — внутренний: он рендерит сами страницы.
 *
 * CatalogProvider стоит ЕЩЁ выше, в main.tsx: каталог локали загружается до первого
 * рендера и не может зависеть ни от роутера, ни от состояния сессии.
 */
export function AppProviders(): ReactElement {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  );
}
